import React, { useEffect } from 'react';
import PrematchContext from '../../../contexts/PrematchContext';
import { getConfiguration } from '../../../data/utils';
import { useTimeline } from '../../../prematch/TimelineProvider';

export default function AllEventsButtons() {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const data = useTimeline();

    useEffect(() => {
        if (prematchContext.daySport && prematchContext.dayCountry && data?.weekDays) {
            const day = data.weekDays.find(d => {
                if (d.sportList?.[prematchContext.daySport]?.categories) {
                    try {
                        return Array.from(d.sportList[prematchContext.daySport].categories)?.find(c => { return c == prematchContext.dayCountry });
                    } catch (err) {
                        console.log(err);
                    }
                }
                return false;
            });
            if (day) {
                day.sport = day.sportList[prematchContext.daySport];
                prematchContext.setDaySelection(day);
            } else if (conf.seo) {
                prematchContext.openPrematchNoEvents();
            }
        }
    }, [data]);

    if (data == null) {
        return null;
    }

    const weekDays = data.weekDays

    function handleClick() {
        conf.iwh ? prematchContext.setDaySelection(weekDays[0]) : prematchContext.setDaySelection(weekDays[weekDays.length - 1]);
    }

    return (
        <>
            {data.weekDays && <a className={`widget__button--allEvent widget__button--noTournements ${prematchContext.section === 'daily-match' && 'active'}`} onClick={() => handleClick()} href-disabled="#!">Tutte le partite</a>}
        </>
    )
}
